import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export function AttachmentThumbnail({ file, url, kind, fallback, alt = '', onError, }) {
    const [local, setLocal] = useState();
    useEffect(() => {
        if (!file?.size || !kind || url)
            return;
        const previewUrl = URL.createObjectURL(file);
        setLocal({ file, url: previewUrl });
        return () => URL.revokeObjectURL(previewUrl);
    }, [file, kind, url]);
    const src = url ?? (local?.file === file ? local?.url : undefined);
    if (!src || !kind)
        return fallback;
    return kind === 'video' ? (_jsx("video", { src: src, muted: true, playsInline: true, preload: "metadata", className: "size-full object-cover", onError: onError })) : (_jsx("img", { src: src, alt: alt, className: "size-full object-cover", onError: onError }));
}
//# sourceMappingURL=AttachmentThumbnail.js.map